const PIXEL_ID = '4370383059953672'

let initialized = false

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

export function initFbPixel(): void {
  if (initialized) return
  if (typeof window === 'undefined') return
  initialized = true

  // 1. Create the fbq queue function (standard Meta snippet)
  ;(function () {
    const n: any = (window.fbq = function (...args: any[]) {
      if (n.callMethod) {
        n.callMethod.apply(n, args)
      } else {
        n.queue.push(args)
      }
    })
    if (!window._fbq) window._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
  })()

  // 2. Inject the fbevents.js script into <head>
  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)

  // 3. Add the noscript image fallback (Pixel Helper looks for this)
  const noscript = document.createElement('img')
  noscript.height = 1
  noscript.width = 1
  noscript.style.display = 'none'
  noscript.setAttribute('alt', '')
  noscript.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`
  document.body.appendChild(noscript)

  // 4. Initialize the pixel
  window.fbq('init', PIXEL_ID)
}

export function trackPageView(): void {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'PageView')
  }
}

export function trackEvent(
  eventName: string,
  params?: Record<string, any>,
): void {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', eventName, params)
  }
}
